export enum PerfilUsuario {
    Administrador = 84,
    Cliente = 67,
    Provedor = 80,
    Ambos = 65
}